exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "figure[data-v-41d2f757]{margin:0}figure .blockquote[data-v-41d2f757]{margin:0 0 1rem;font-size:1.25rem}figure .blockquote[data-v-41d2f757]>:last-child,figure .blockquote p[data-v-41d2f757]{margin-bottom:0}.blockquote-footer[data-v-41d2f757]{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer[data-v-41d2f757]:before{content:\"\\2014   \"}", ""]);

// exports
